import { OAuthToken } from '@vsf-enterprise/sapcc-api';
import { Context } from '@vue-storefront/core';
import { AUTH_USER_TOKEN_COOKIE_NAME } from '@vsf-enterprise/sapcc';

export const getCurrentToken = (
  context: Context,
  refreshedUserToken?: OAuthToken | null
) => {
  return refreshedUserToken || context.app.$cookies.get(AUTH_USER_TOKEN_COOKIE_NAME);
};
